import { serializeQuery } from "@/utils/UrlUtils";
import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiAudits {
  static getAudits(params) {
    let query = serializeQuery(params);
    if (query) query = `?${query}`;
    return apiFetch(`${ApiBaseUrl}audits${query}`);
  }

  static getFilters() {
    return apiFetch(`${ApiBaseUrl}audits/filters`);
  }
}
